import { AJOUTE_DATA_RESTAURANT, SUPRIMER_DATA_RESTAURANT } from '../types/typeDataRestaurant';

export const AjouteDataRestaurant = (restaurant) => {
    return {
        type: AJOUTE_DATA_RESTAURANT,
        payload: restaurant
    }
}

export const SuprimerDataRestaurant = (restaurant) => {
    return {
        type: SUPRIMER_DATA_RESTAURANT,
        payload: restaurant
    }
}